
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import IconGroupOfCode from '../components/svg/IconGroupOfCode.vue'
import IconMiniCode from '../components/svg/IconMiniCode.vue'
import IconQRcode from '../components/svg/IconQRcode.vue'
import IconVaccine from '../components/svg/IconVaccine.vue'
import IconTruck from '../components/svg/IconTruck.vue'
import IconContainer from '../components/svg/IconContainer.vue'
import IconTimeTable from '../components/svg/IconTimeTable.vue'
import { BARCODE_ICONS } from '../utils/constants'
import { IBarcodeDefinitionType } from '@/utils/types'

@Options({
  emits: ['icon:click'],
})
export default class BarcodeIconLabel extends Vue {
  @Prop({ default: false }) readonly clickable?: boolean
  @Prop({ type: Object }) readonly barcodeTypeInfo!: IBarcodeDefinitionType

  barcodeIconComponents = {
    [BARCODE_ICONS.NODE]: IconGroupOfCode,
    [BARCODE_ICONS.LEAF]: IconMiniCode,
    [BARCODE_ICONS.ORPHAN]: IconQRcode,
    [BARCODE_ICONS.VACCINE]: IconVaccine,
    [BARCODE_ICONS.TRUCK]: IconTruck,
    [BARCODE_ICONS.CONTAINER]: IconContainer,
    [BARCODE_ICONS.TIMETABLE]: IconTimeTable,
  }

  barcodeButtonStyles = (barcodeTypeInfo: IBarcodeDefinitionType) => {
    return barcodeTypeInfo
      ? {
          color: `${barcodeTypeInfo.foregroundColor} !important`,
          background: `${barcodeTypeInfo.backgroundColor} !important`,
          'border-color': `${barcodeTypeInfo.backgroundColor} !important`,
        }
      : {}
  }

  barcodeIconStyles = (barcodeTypeInfo: IBarcodeDefinitionType) => {
    return { color: barcodeTypeInfo?.invertIconColor ? '#000' : '#fff' }
  }
}
